import React, { useEffect, useState } from "react";
import { fetchTeamAssociates } from "../../../containers/actions/common/teamMemberAction";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Drawer,
  Grid,
  makeStyles,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";
import InviteTeamMember from "./inviteTeamMember";
import ViewDetails from "../teamMembers/invitationView/ViewDetails";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  active: {
    backgroundColor: "#2e7d32",
    width: "6rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  inactive: {
    backgroundColor: "#f44336",
    width: "6rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  searchField: {
    marginBottom: theme.spacing(2),
  },
  upload: {
    background: "#c8ddfb",
    color: "black",
    textTransform: "none",
    borderRadius: "2rem",
    // marginRight: 20,
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "#6495ED",
      color: "white",
    },
  },
  drawerPaper: {
    width: "30vw", // Set the drawer width here
  },
  multipleLogo: {
    border: "1px solid #7d7c7c",
    borderRadius: "4px",
    padding: "0.3rem",
    height: "inherit",
    marginLeft: "0.5rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid #FFF",
    },
  },
}));

const ViewTeamMembersColumn = ({
  selectedRole,
  openDialog,
  handleCloseColumn,
  featuresAccessTeamMembers,
  handleRefresh,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [inviteDrawer, setInviteDrawer] = useState(false);
  const [ViewDetailsDrawer, setViewDetailsDrawer] = useState(false);
  const [user, setUser] = useState({});
  const [view, setView] = useState("TeamMembers");
  const teamMembersList = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetails;
  });

  const teamMembersListLoading = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetailsLoading || {};
  });

  useEffect(() => {
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        departmentID: selectedRole.departmentID,
        collaborator_role_id: selectedRole.collaborator_role_id,
        searchString: "all",
        status: "Active",
      })
    );
  }, []);

  const UserAvatar = ({ profileImage, profileName }) => {
    return (
      <Box display="flex" alignItems="center">
        <Avatar
          src={profileImage} // Use the Base64 string here
          alt={profileName} // Optional: Alt text for accessibility
          style={{ marginRight: "8px" }} // Adjust spacing if needed
        />
      </Box>
    );
  };

  const handleTabChange = (event, newValue) => {
    setView(newValue);
  };

  const handleDetailView = (user) => {
    setUser(user);
    setViewDetailsDrawer(true);
    // fetchDepartmentsList
  };
  const fetchDepartmentsList = [];

  const renderViewTeamMembers = () => (
    <div>
      <TableContainer
        component={Paper}
        style={{
          borderLeft: "1px solid #bdbdbd",
          borderRight: "1px solid #bdbdbd",
          borderBottom: "1px solid #bdbdbd",
        }}
      >
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Team Member</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Employee Number</TableCell>
              <TableCell>Department - Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teamMembersListLoading === true ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            ) : teamMembersList?.data?.length > 0 ? (
              teamMembersList?.data
                ?.filter((member) => member.account_status === "Active")
                .map((member, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.3rem",
                      }}
                    >
                      <Grid>
                        <UserAvatar profileImage={member?.profile_pic} />
                      </Grid>
                      <Grid
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography>{member?.full_name || ""}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {member?.email_address || ""}
                        </Typography>
                      </Grid>
                    </TableCell>
                    <TableCell>
                      {!member?.phone_number ||
                        member?.phone_number?.trim() === "" ||
                        member?.phone_number?.toLowerCase() === "null"
                        ? ""
                        : member.phone_number}
                    </TableCell>
                    <TableCell>{member?.employee_number || ""}</TableCell>
                    <TableCell>
                      {/* {member?.department_name || "NA"} */}
                      {`${member?.department_name || ""} - ${member?.roleName || ""
                        }`}
                      <br />
                      <Typography variant="body2" color="textSecondary">
                        {member?.access ? `${member.access} access` : "Parial access"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <span
                        className={
                          member.account_status === "Active"
                            ? classes.active
                            : classes.inactive
                        }
                      >
                        {member?.account_status || ""}
                      </span>
                    </TableCell>
                    <TableCell>
                      {(localStorage?.roleName === "Admin" &&
                  (localStorage?.departmentId === "null" ||
                 Number(localStorage?.getItem("departmentId")) === 1 ))
                  // || Number(localStorage?.departmentId) ===
                  //       member.departmentID)
                         &&
                        featuresAccessTeamMembers?.viewTeamMemberDetails && (
                          <VisibilityIcon
                            fontSize="small"
                            className={classes.multipleLogo}
                            onClick={() => handleDetailView(member)}
                          />
                        )}
                    </TableCell>
                  </TableRow>
                ))
            ) : teamMembersList?.status === false ? (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={10} align="center">
                  'Something went wrong. Please contact Schrocken support.'
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Drawer
        anchor="right"
        open={ViewDetailsDrawer}
        onClose={() => setViewDetailsDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
      // hideBackdrop={true}
      >
        <ViewDetails
          user={user}
          departmentDetails={fetchDepartmentsList}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
        />
      </Drawer>
    </div>
  );

  return (
    <div>
      <Dialog open={openDialog} fullScreen>
        <Grid
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
          container
          direction="column"
        >
          {/* Header Section */}
          <Grid
            container
            // alignItems="center"
            // justifyContent="space-between"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              startIcon={<ArrowBackIosIcon />}
              onClick={handleCloseColumn}
              style={{ textTransform: "none", fontWeight: "550" }}
            >
              Back
            </Button>
          </Grid>

          <Grid container alignItems="center">
            <Typography
              variant="h5"
              style={{ fontWeight: "600" }}
              display="inline"
            >
              {selectedRole?.departmentName
                ? selectedRole?.departmentName
                : ""}{" "}
              -{" "}
            </Typography>
            <Typography
              variant="h5"
              display="inline"
              style={{
                cursor: "pointer",
                fontWeight: "600",
                // textDecoration: roleName !== initialRoleName ? 'underline' : 'none',
              }}
            >
              {selectedRole?.role_name ? selectedRole?.role_name : ""}
            </Typography>
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              gap: "2rem",
            }}
          >
            <Typography variant="body2" color="black">
              {selectedRole?.roleType ? selectedRole?.roleType : ""}
            </Typography>
          </Grid>
        </Grid>

        <DialogContent
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
        >
          <Tabs
            value={view}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="secondary"
          >
            <Tab
              style={{ color: view === "TeamMembers" ? "#1890ff" : "black" }}
              // label="Team Members"
              label={`Team Members (${selectedRole?.userCount || 0})`}
              value="TeamMembers"
            />
          </Tabs>
          <Grid item xs={12}>
            {view === "TeamMembers" && renderViewTeamMembers()}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ViewTeamMembersColumn;
